import type { RotasDoModulo } from '@/app/rotas';

import { OperationDetailPage } from './OperationDetailPage';
import { OperationTimelinePage } from './OperationTimelinePage';
import { OperationsPage } from './OperationsPage';
import { NewQuotePfWizard } from './quote/NewQuotePfWizard';
import { NewQuoteWizard } from './quote/NewQuoteWizard';
import {
  CommercialQueuePage,
  CreditQueuePage,
  IssuanceQueuePage,
  LegalQueuePage,
  UnderwritingQueuePage,
} from './StageQueuePage';

/** A lista de operacoes, as filas por etapa e a Operacao 360. */
export const rotas: RotasDoModulo = {
  menu: {
    '/operacoes': OperationsPage,
    '/credito': CreditQueuePage,
    '/subscricao': UnderwritingQueuePage,
    '/juridico': LegalQueuePage,
    '/comercial': CommercialQueuePage,
    '/emissao': IssuanceQueuePage,
  },
  moldura: [
    // Assistente de nova cotacao da corretora (P-NCT): um passo por segmento, opcional
    // (sem passo, abre o do tomador). Uma rota so por modo, para que trocar de passo
    // nao desmonte o assistente e o rascunho continue.
    { path: '/operacoes/nova/:passo?', element: <NewQuoteWizard /> },
    { path: '/operacoes/:operationId/editar/:passo?', element: <NewQuoteWizard /> },
    // Nova cotacao de pessoa fisica, a do leiloeiro (P-NCT-3).
    { path: '/operacoes/nova-pf/:passo?', element: <NewQuotePfWizard /> },
    { path: '/operacoes/:operationId', element: <OperationDetailPage /> },
    // Linha do tempo da cotacao, pagina propria como no OnPoint (P-COT-3).
    {
      path: '/operacoes/:operationId/linha-do-tempo',
      element: <OperationTimelinePage />,
    },
  ],
};
